import { useState, useEffect } from "react";

const useIsTabletSize = () => {
  const getValue = () => {
    if (typeof window === "undefined") return false;

    return window.innerWidth <= 1024; // tablet breakpoint
  };

  const [isTabletSize, setIsTabletSize] = useState(getValue);

  useEffect(() => {
    const handleResize = () => setIsTabletSize(getValue());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isTabletSize;
};

export default useIsTabletSize;
